// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webhook-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
}

@media (min-width: 1400px) {
  .webhook-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .webhook-list {
    grid-template-columns: 1fr;
  }
}

.webhook-list-empty {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  color: #6b7280;
  font-size: 16px;
}

.webhook-card {
  background: white;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.webhook-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-4px);
  border-color: #667eea;
}

.webhook-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f3f4f6;
}

.webhook-card-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.status-badge {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-200 {
  background: #d1fae5;
  color: #065f46;
}

.status-500 {
  background: #fee2e2;
  color: #991b1b;
}

.status-404 {
  background: #fef3c7;
  color: #92400e;
}

.webhook-card-body {
  margin-bottom: 20px;
}

.webhook-url-section {
  margin-bottom: 20px;
}

.webhook-url-section label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.url-container {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9fafb;
  padding: 12px 16px;
  border-radius: 8px;
  border: 2px solid #e5e7eb;
}

.webhook-url {
  flex: 1 1;
  font-size: 13px;
  color: #1f2937;
  word-break: break-all;
  font-family: 'Courier New', monospace;
}

.btn-copy {
  background: #667eea;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  flex-shrink: 0;
}

.btn-copy:hover {
  background: #5568d3;
  transform: scale(1.05);
}

.webhook-info {
  display: grid;
  gap: 12px;
  font-size: 14px;
  color: #6b7280;
}

.webhook-info strong {
  color: #374151;
  font-weight: 600;
}

.webhook-card-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 2px solid #f3f4f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/WebhookList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":[".webhook-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 24px;\n}\n\n@media (min-width: 1400px) {\n  .webhook-list {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .webhook-list {\n    grid-template-columns: 1fr;\n  }\n}\n\n.webhook-list-empty {\n  text-align: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  color: #6b7280;\n  font-size: 16px;\n}\n\n.webhook-card {\n  background: white;\n  border-radius: 16px;\n  padding: 28px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s;\n  border: 2px solid transparent;\n}\n\n.webhook-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n  transform: translateY(-4px);\n  border-color: #667eea;\n}\n\n.webhook-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #f3f4f6;\n}\n\n.webhook-card-header h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.status-badge {\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-200 {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-500 {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-404 {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.webhook-card-body {\n  margin-bottom: 20px;\n}\n\n.webhook-url-section {\n  margin-bottom: 20px;\n}\n\n.webhook-url-section label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #374151;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.url-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #f9fafb;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 2px solid #e5e7eb;\n}\n\n.webhook-url {\n  flex: 1;\n  font-size: 13px;\n  color: #1f2937;\n  word-break: break-all;\n  font-family: 'Courier New', monospace;\n}\n\n.btn-copy {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.btn-copy:hover {\n  background: #5568d3;\n  transform: scale(1.05);\n}\n\n.webhook-info {\n  display: grid;\n  gap: 12px;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.webhook-info strong {\n  color: #374151;\n  font-weight: 600;\n}\n\n.webhook-card-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 2px solid #f3f4f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
